import ReactDOM from "react-dom/client";
import {Approutes,subrutas} from "./routes/Approutes.js";
import Layout from "./components/Layout/Layout.jsx";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./slice/login.js";
import UserReducer from "./slice/usuarios.js";
import globalReducer from "./slice/global.js";
import NotFound from "./components/NotFound.jsx";
import 'bootstrap/dist/js/bootstrap.bundle';

const store=configureStore({
  reducer:{
    login:loginReducer,
    usuarios:UserReducer,
    global:globalReducer
  }
});

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(
  <Provider store={store}>
    <BrowserRouter basename={`${process.env.URIURL}`}>
    <Routes>
      {Approutes.map((prop, key) => {
        return <Route path={`${prop.path}`} element={prop.template?<Layout>{prop.component}</Layout>:prop.component} key={key} /> 
      })}
      {subrutas.map((prop, key) => {
        return <Route path={`${prop.path}`} key={key} element={<Layout>{prop.component}</Layout>}/> 
      })}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
  </Provider>);
 